import axios from '@/plugins/axios';

export const getUserProspects = async (userId) => {
  const { data } = await axios.get(`/users/${userId}/prospects`);

  return data?.data;
};

export const createUserProspect = async (userId, prospect) => {
  const { data } = await axios.post(`/users/${userId}/prospects`, {
    ...prospect,
  });

  return data?.data;
};

export const updateUserProspect = async (prospectId, prospect) => {
  const { data } = await axios.put(`/prospects/${prospectId}`, {
    ...prospect,
  });

  return data?.data;
};

export const deleteUserProspect = async (prospectId) => {
  await axios.delete(`/prospects/${prospectId}`);
};
